import { SkeletonProps } from '@mui/material';

type AvatarVariant = 'circular' | 'rounded' | 'square';

export const avatarLoadingVariantMap: Record<AvatarVariant, SkeletonProps['variant']> = {
  circular: 'circular',
  rounded: 'rectangular',
  square: 'rectangular',
};
